module.exports = __webpack_public_path__ + "assets/img/08-s.20af613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/08-s.jpg
// module id = Dl04
// module chunks = 0